// @core/api/endpoints/fiscalization/delete_fiscal_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/fiscalization';

/**
 * Delete fiscal provider
 * Removes a fiscal provider configuration. Active fiscal points using this provider must be reassigned first.
 */
export async function DeleteFiscalProvider(
  id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-providers/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
